import { useShallow } from 'zustand/react/shallow';
import { useRachelScope } from '../contexts/RachelScope.context';
import { getRachelScopeKey } from '../effects/rachelScope';
import useRachelChangesStore from '../store/rachelChanges.store';
import { useRachelEffectStyles } from '../styles/rachelEffects.styles';

export const useRachelListItem = (itemKey: string) => {
  const scope = useRachelScope();
  const { classes } = useRachelEffectStyles();
  const scopeKey = scope ? getRachelScopeKey(scope) : '';

  const { isAdded, isRemoved } = useRachelChangesStore(
    useShallow((state) => ({
      isAdded: !!state.addedKeysByScope[scopeKey]?.includes(itemKey),
      isRemoved: !!state.removedKeysByScope[scopeKey]?.includes(itemKey),
    })),
  );

  if (isRemoved) {
    return { className: classes.removed };
  }

  return { className: isAdded ? classes.added : undefined };
};
